import React from 'react';
import { BackSide } from 'three';
import { useDebugMode } from '../../../hooks/useDebugMode';

interface PanoramaSphereProps {
  texture: any;
  roomName?: string;
}

/**
 * Componente riutilizzabile per la sfera panoramica con debug mode integrato.
 * Premi Ctrl+Shift+D (o Cmd+Shift+D su Mac) per attivare/disattivare la modalità debug.
 */
const PanoramaSphere: React.FC<PanoramaSphereProps> = ({ texture, roomName = 'Unknown' }) => {
  const debugMode = useDebugMode();

  const handleClick = (event: any) => {
    if (!debugMode) return;

    event.stopPropagation();
    const point = event.point;

    /*console.log('\n=================================');
    console.log(`📍 Room: ${roomName}`);
    console.log(`📌 Position: [${point.x.toFixed(2)}, ${point.y.toFixed(2)}, ${point.z.toFixed(2)}]`);
    console.log(`\n📋 Copy this line:`);
    console.log(`<Hotspot position={[${point.x.toFixed(2)}, ${point.y.toFixed(2)}, ${point.z.toFixed(2)}]} onClick={() => services.openAGDrawer(YOUR_ID)} />`);
    console.log('=================================\n');*/
  };

  return (
    <mesh onClick={handleClick}>
      <sphereGeometry args={[500, 60, 40]} />
      <meshBasicMaterial map={texture} side={BackSide} />
    </mesh>
  );
};

export default PanoramaSphere;
